import { BrowserRouter as Router, Route, Routes, Outlet } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Toaster } from 'react-hot-toast';

import Main from "./components/layout/Main";
import Home from "./components/Home";
import Leave from "./components/leave";
import Attendance from "./components/attendance";
import Payroll from "./components/payrole";
import Login from "./components/Login";
import ChangePassword from "./components/changepassword"
import PayrollView from "./components/payrole/PayrollView";
import Target from "./components/target";
import Order from "./components/order";
import OrderWizard from './components/order/OrderWizard'
import Voucher from "./components/voucher"
import Ledger from "./components/ledger"
import Reports from "./components/reports/Reports";
import Task from "./components/task";
import TaskWizard from "./components/task/TaskWizard";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Sidebar.css"
import Error from "./components/common/Error";
import StockItem from "./components/stockitem/StockItem";
import CalendarDashboard from "./components/calender/CalendarDashboard";

function App() {
  const [isLogout, setIsLogout] = useState(false);

  useEffect(() => {
  }, [isLogout])

  return (
    <>
      <Toaster position='top-center' />

      <Router>
        <Routes>

          <Route path="/" element={localStorage.getItem('token') ? <Main setIsLogout={setIsLogout} /> : <Login setIsLogout={setIsLogout} />} >
            <Route index element={<Home />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="payroll" element={<Outlet />} >
              <Route index element={<Payroll />} />
              <Route path="view/:id" element={<PayrollView />} />
            </Route>
            <Route path="leave" element={<Leave />} />
            <Route path='target' element={<Target />} />
            <Route path="order" element={<Order />} />
            <Route path="/order/create" element={<OrderWizard />} />
            <Route path="/order/edit" element={<OrderWizard />} />
            <Route path="voucher" element={<Voucher />} />
            <Route path="ledger" element={<Ledger />} />
            <Route path="stock-items" element={<StockItem />} />
            <Route path="reports" element={<Reports />} />
            <Route path="task" element={<Task />} />
            <Route path="event" element={<CalendarDashboard />} />
            <Route path="task/edit" element={<TaskWizard />} />
            <Route path="changepassword" element={<ChangePassword />} />
          </Route>

          <Route path="/*" element={<Error />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
